module.exports = __webpack_public_path__ + "static/media/smile1.263c1085.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/smileImg/smile1.png
// module id = 74
// module chunks = 0